import { render, staticRenderFns } from "./StarRatingRow.vue?vue&type=template&id=0b894f60&scoped=true&"
import script from "./StarRatingRow.vue?vue&type=script&lang=ts&"
export * from "./StarRatingRow.vue?vue&type=script&lang=ts&"
import style0 from "./StarRatingRow.vue?vue&type=style&index=0&id=0b894f60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b894f60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VProgressLinear,VRow})
